import { render, staticRenderFns } from "./departmentAdd.vue?vue&type=template&id=2a918332&scoped=true&"
import script from "./departmentAdd.vue?vue&type=script&lang=js&"
export * from "./departmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./departmentAdd.vue?vue&type=style&index=0&id=2a918332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a918332",
  null
  
)

export default component.exports